// Copy for sharing outside proef (WhatsApp, mail, SMS, the system sheet): the invitation to a
// session, the result of a tasting and a shareable card, plus the screens around them. The messages
// are written in the sender's language, short and plain, and name the host. One entry per locale;
// every key exists in all seven (nl is the source, the rest are translations).
export const shareCopy = {
  nl: {
    "share.friend.title": "{host} nodigt je uit voor proef",
    "share.friend.text": "Proef samen met mij in proef:",
    "share.group.title": "Proef samen met {group}",
    "share.group.text": "Proef samen met {group} in proef:",
    "share.session.title": "{host} nodigt je uit om te proeven",
    "share.session.text": "Proef samen met mij bij {session}:",
    "share.join.title": "Proef mee met {host}",
    "share.join.text": "Doe mee met mijn proeverij:",
    "share.result.title": "Mijn proeverij op proef",
    "share.result.session.text": "Ik deel mijn proeverij {session} met je:",
    "share.result.wine.text": "Ik proefde {wine}:",
    "share.result.flight.text": "Ik deel de uitslag van {title} met je:",
    "share.card.title": "Mijn proefkaart",
    "share.card.week.text": "Mijn proefweek ({period}): {wines} wijnen, {notes} notities.",
    "share.card.month.text": "Mijn proefmaand ({period}): {wines} wijnen, {notes} notities.",
    "social.invite.session.title": "Nodig mensen uit voor {session}",
    "social.invite.session.lead":
      "Wie de link opent en inlogt, komt op de lijst en doet mee. De link werkt tot de proeverij voorbij is.",
    "social.invite.joined.remove": "Verwijder {name}",
    "social.invite.landing.session": "{name} nodigt je uit voor {session}.",
    "social.invite.outcome.session": "Je komt naar de proeverij.",
    "social.invite.outcome.toSession": "Naar de proeverij",
    "social.invite.outcome.toLobby": "Naar de lobby",
    "social.invite.install.title": "Zet proef op je beginscherm",
    "social.invite.install.body": "Dan vind je de proeverij zo weer terug.",
    "social.invite.install.action": "Installeren",
    "social.session.invite.share": "Uitnodigingslink",
    "social.inbox.link.session": "Link voor {session}",
    "social.share.sheet.title": "Deel buiten proef",
    "social.share.sheet.lead.result": "Alleen de naam van de proeverij gaat mee, geen notities.",
    "social.share.sheet.lead.wine": "Alleen de naam van de wijn gaat mee, niet je notitie.",
    "social.share.sheet.lead.card":
      "De aantallen van je kaart gaan mee, geen notities. Wie de link opent ziet niets van je account.",
    "social.share.result.action": "Deel de uitslag",
    "social.share.tasting.action": "Deel",
    "social.share.card.external": "Deel buiten proef",
    "social.groups.planTasting": "Plan een proeverij",
    "social.sessions.create.friends": "Of nodig vrienden uit",
    "social.sessions.create.noFriends": "Je hebt nog geen vrienden om uit te nodigen.",
  },
  en: {
    "share.friend.title": "{host} invites you to proef",
    "share.friend.text": "Taste wine with me in proef:",
    "share.group.title": "Taste together with {group}",
    "share.group.text": "Taste wine with {group} in proef:",
    "share.session.title": "{host} invites you to taste",
    "share.session.text": "Taste together with me at {session}:",
    "share.join.title": "Taste along with {host}",
    "share.join.text": "Join my tasting:",
    "share.result.title": "My tasting on proef",
    "share.result.session.text": "I am sharing my tasting {session} with you:",
    "share.result.wine.text": "I tasted {wine}:",
    "share.result.flight.text": "I am sharing the results of {title} with you:",
    "share.card.title": "My tasting card",
    "share.card.week.text": "My tasting week ({period}): {wines} wines, {notes} notes.",
    "share.card.month.text": "My tasting month ({period}): {wines} wines, {notes} notes.",
    "social.invite.session.title": "Invite people to {session}",
    "social.invite.session.lead":
      "Whoever opens the link and signs in joins the list and takes part. The link works until the tasting is over.",
    "social.invite.joined.remove": "Remove {name}",
    "social.invite.landing.session": "{name} invites you to {session}.",
    "social.invite.outcome.session": "You are coming to the tasting.",
    "social.invite.outcome.toSession": "To the tasting",
    "social.invite.outcome.toLobby": "To the lobby",
    "social.invite.install.title": "Put proef on your home screen",
    "social.invite.install.body": "That way the tasting is easy to find again.",
    "social.invite.install.action": "Install",
    "social.session.invite.share": "Invite link",
    "social.inbox.link.session": "Link for {session}",
    "social.share.sheet.title": "Share outside proef",
    "social.share.sheet.lead.result": "Only the name of the tasting goes along, no notes.",
    "social.share.sheet.lead.wine": "Only the name of the wine goes along, not your note.",
    "social.share.sheet.lead.card":
      "The numbers on your card go along, no notes. Whoever opens the link sees nothing of your account.",
    "social.share.result.action": "Share the results",
    "social.share.tasting.action": "Share",
    "social.share.card.external": "Share outside proef",
    "social.groups.planTasting": "Plan a tasting",
    "social.sessions.create.friends": "Or invite friends",
    "social.sessions.create.noFriends": "You have no friends to invite yet.",
  },
  de: {
    "share.friend.title": "{host} lädt dich zu proef ein",
    "share.friend.text": "Verkoste mit mir in proef:",
    "share.group.title": "Verkoste zusammen mit {group}",
    "share.group.text": "Verkoste mit {group} in proef:",
    "share.session.title": "{host} lädt dich zum Verkosten ein",
    "share.session.text": "Verkoste mit mir zusammen bei {session}:",
    "share.join.title": "Verkoste mit {host}",
    "share.join.text": "Mach bei meiner Verkostung mit:",
    "share.result.title": "Meine Verkostung auf proef",
    "share.result.session.text": "Ich teile meine Verkostung {session} mit dir:",
    "share.result.wine.text": "Ich habe {wine} verkostet:",
    "share.result.flight.text": "Ich teile die Ergebnisse von {title} mit dir:",
    "share.card.title": "Meine Verkostungskarte",
    "share.card.week.text": "Meine Verkostungswoche ({period}): {wines} Weine, {notes} Notizen.",
    "share.card.month.text": "Mein Verkostungsmonat ({period}): {wines} Weine, {notes} Notizen.",
    "social.invite.session.title": "Leute zu {session} einladen",
    "social.invite.session.lead":
      "Wer den Link öffnet und sich anmeldet, steht auf der Liste und macht mit. Der Link gilt, bis die Verkostung vorbei ist.",
    "social.invite.joined.remove": "{name} entfernen",
    "social.invite.landing.session": "{name} lädt dich zu {session} ein.",
    "social.invite.outcome.session": "Du kommst zur Verkostung.",
    "social.invite.outcome.toSession": "Zur Verkostung",
    "social.invite.outcome.toLobby": "Zur Lobby",
    "social.invite.install.title": "proef auf den Startbildschirm legen",
    "social.invite.install.body": "So findest du die Verkostung leicht wieder.",
    "social.invite.install.action": "Installieren",
    "social.session.invite.share": "Einladungslink",
    "social.inbox.link.session": "Link für {session}",
    "social.share.sheet.title": "Außerhalb von proef teilen",
    "social.share.sheet.lead.result":
      "Nur der Name der Verkostung wird mitgeschickt, keine Notizen.",
    "social.share.sheet.lead.wine": "Nur der Name des Weins wird mitgeschickt, nicht deine Notiz.",
    "social.share.sheet.lead.card":
      "Die Zahlen deiner Karte werden mitgeschickt, keine Notizen. Wer den Link öffnet, sieht nichts von deinem Konto.",
    "social.share.result.action": "Ergebnisse teilen",
    "social.share.tasting.action": "Teilen",
    "social.share.card.external": "Außerhalb von proef teilen",
    "social.groups.planTasting": "Eine Verkostung planen",
    "social.sessions.create.friends": "Oder Freunde einladen",
    "social.sessions.create.noFriends": "Du hast noch keine Freunde zum Einladen.",
  },
  fr: {
    "share.friend.title": "{host} t'invite sur proef",
    "share.friend.text": "Déguste avec moi sur proef :",
    "share.group.title": "Déguste avec {group}",
    "share.group.text": "Déguste avec {group} sur proef :",
    "share.session.title": "{host} t'invite à déguster",
    "share.session.text": "Déguste avec moi chez {session} :",
    "share.join.title": "Déguste avec {host}",
    "share.join.text": "Rejoins ma dégustation :",
    "share.result.title": "Ma dégustation sur proef",
    "share.result.session.text": "Je partage ma dégustation {session} avec toi :",
    "share.result.wine.text": "J'ai dégusté {wine} :",
    "share.result.flight.text": "Je partage les résultats de {title} avec toi :",
    "share.card.title": "Ma carte de dégustation",
    "share.card.week.text": "Ma semaine de dégustation ({period}) : {wines} vins, {notes} notes.",
    "share.card.month.text": "Mon mois de dégustation ({period}) : {wines} vins, {notes} notes.",
    "social.invite.session.title": "Inviter des gens à {session}",
    "social.invite.session.lead":
      "Quiconque ouvre le lien et se connecte rejoint la liste et participe. Le lien fonctionne jusqu'à la fin de la dégustation.",
    "social.invite.joined.remove": "Retirer {name}",
    "social.invite.landing.session": "{name} t'invite à {session}.",
    "social.invite.outcome.session": "Tu viens à la dégustation.",
    "social.invite.outcome.toSession": "Vers la dégustation",
    "social.invite.outcome.toLobby": "Vers le salon",
    "social.invite.install.title": "Mets proef sur ton écran d'accueil",
    "social.invite.install.body": "Tu retrouveras ainsi facilement la dégustation.",
    "social.invite.install.action": "Installer",
    "social.session.invite.share": "Lien d'invitation",
    "social.inbox.link.session": "Lien pour {session}",
    "social.share.sheet.title": "Partager hors de proef",
    "social.share.sheet.lead.result": "Seul le nom de la dégustation est envoyé, aucune note.",
    "social.share.sheet.lead.wine": "Seul le nom du vin est envoyé, pas ta note.",
    "social.share.sheet.lead.card":
      "Les chiffres de ta carte sont envoyés, aucune note. Qui ouvre le lien ne voit rien de ton compte.",
    "social.share.result.action": "Partager les résultats",
    "social.share.tasting.action": "Partager",
    "social.share.card.external": "Partager hors de proef",
    "social.groups.planTasting": "Planifier une dégustation",
    "social.sessions.create.friends": "Ou invite des amis",
    "social.sessions.create.noFriends": "Tu n'as pas encore d'amis à inviter.",
  },
  es: {
    "share.friend.title": "{host} te invita a proef",
    "share.friend.text": "Cata vino conmigo en proef:",
    "share.group.title": "Cata con {group}",
    "share.group.text": "Cata vino con {group} en proef:",
    "share.session.title": "{host} te invita a catar",
    "share.session.text": "Cata conmigo en {session}:",
    "share.join.title": "Cata con {host}",
    "share.join.text": "Únete a mi cata:",
    "share.result.title": "Mi cata en proef",
    "share.result.session.text": "Comparto contigo mi cata {session}:",
    "share.result.wine.text": "He catado {wine}:",
    "share.result.flight.text": "Comparto contigo los resultados de {title}:",
    "share.card.title": "Mi tarjeta de cata",
    "share.card.week.text": "Mi semana de cata ({period}): {wines} vinos, {notes} notas.",
    "share.card.month.text": "Mi mes de cata ({period}): {wines} vinos, {notes} notas.",
    "social.invite.session.title": "Invita a gente a {session}",
    "social.invite.session.lead":
      "Quien abra el enlace e inicie sesión entra en la lista y participa. El enlace funciona hasta que termine la cata.",
    "social.invite.joined.remove": "Quitar a {name}",
    "social.invite.landing.session": "{name} te invita a {session}.",
    "social.invite.outcome.session": "Vienes a la cata.",
    "social.invite.outcome.toSession": "A la cata",
    "social.invite.outcome.toLobby": "Al vestíbulo",
    "social.invite.install.title": "Pon proef en tu pantalla de inicio",
    "social.invite.install.body": "Así encontrarás la cata fácilmente.",
    "social.invite.install.action": "Instalar",
    "social.session.invite.share": "Enlace de invitación",
    "social.inbox.link.session": "Enlace para {session}",
    "social.share.sheet.title": "Compartir fuera de proef",
    "social.share.sheet.lead.result": "Solo se envía el nombre de la cata, ninguna nota.",
    "social.share.sheet.lead.wine": "Solo se envía el nombre del vino, no tu nota.",
    "social.share.sheet.lead.card":
      "Se envían los números de tu tarjeta, ninguna nota. Quien abra el enlace no ve nada de tu cuenta.",
    "social.share.result.action": "Compartir los resultados",
    "social.share.tasting.action": "Compartir",
    "social.share.card.external": "Compartir fuera de proef",
    "social.groups.planTasting": "Planear una cata",
    "social.sessions.create.friends": "O invita a amigos",
    "social.sessions.create.noFriends": "Aún no tienes amigos a quienes invitar.",
  },
  it: {
    "share.friend.title": "{host} ti invita su proef",
    "share.friend.text": "Degusta con me su proef:",
    "share.group.title": "Degusta con {group}",
    "share.group.text": "Degusta con {group} su proef:",
    "share.session.title": "{host} ti invita a degustare",
    "share.session.text": "Degusta con me da {session}:",
    "share.join.title": "Degusta con {host}",
    "share.join.text": "Unisciti alla mia degustazione:",
    "share.result.title": "La mia degustazione su proef",
    "share.result.session.text": "Condivido con te la mia degustazione {session}:",
    "share.result.wine.text": "Ho degustato {wine}:",
    "share.result.flight.text": "Condivido con te i risultati di {title}:",
    "share.card.title": "La mia scheda di degustazione",
    "share.card.week.text":
      "La mia settimana di degustazione ({period}): {wines} vini, {notes} note.",
    "share.card.month.text": "Il mio mese di degustazione ({period}): {wines} vini, {notes} note.",
    "social.invite.session.title": "Invita persone a {session}",
    "social.invite.session.lead":
      "Chi apre il link e accede entra nell'elenco e partecipa. Il link funziona fino alla fine della degustazione.",
    "social.invite.joined.remove": "Rimuovi {name}",
    "social.invite.landing.session": "{name} ti invita a {session}.",
    "social.invite.outcome.session": "Vieni alla degustazione.",
    "social.invite.outcome.toSession": "Alla degustazione",
    "social.invite.outcome.toLobby": "Alla sala d'attesa",
    "social.invite.install.title": "Metti proef nella schermata iniziale",
    "social.invite.install.body": "Così ritrovi facilmente la degustazione.",
    "social.invite.install.action": "Installa",
    "social.session.invite.share": "Link di invito",
    "social.inbox.link.session": "Link per {session}",
    "social.share.sheet.title": "Condividi fuori da proef",
    "social.share.sheet.lead.result": "Va solo il nome della degustazione, nessuna nota.",
    "social.share.sheet.lead.wine": "Va solo il nome del vino, non la tua nota.",
    "social.share.sheet.lead.card":
      "Vanno i numeri della tua scheda, nessuna nota. Chi apre il link non vede nulla del tuo account.",
    "social.share.result.action": "Condividi i risultati",
    "social.share.tasting.action": "Condividi",
    "social.share.card.external": "Condividi fuori da proef",
    "social.groups.planTasting": "Pianifica una degustazione",
    "social.sessions.create.friends": "Oppure invita degli amici",
    "social.sessions.create.noFriends": "Non hai ancora amici da invitare.",
  },
  pt: {
    "share.friend.title": "{host} convida-te para o proef",
    "share.friend.text": "Prova vinho comigo no proef:",
    "share.group.title": "Prova com {group}",
    "share.group.text": "Prova vinho com {group} no proef:",
    "share.session.title": "{host} convida-te a provar",
    "share.session.text": "Prova comigo em {session}:",
    "share.join.title": "Prova com {host}",
    "share.join.text": "Junta-te à minha prova:",
    "share.result.title": "A minha prova no proef",
    "share.result.session.text": "Partilho contigo a minha prova {session}:",
    "share.result.wine.text": "Provei {wine}:",
    "share.result.flight.text": "Partilho contigo os resultados de {title}:",
    "share.card.title": "O meu cartão de prova",
    "share.card.week.text": "A minha semana de provas ({period}): {wines} vinhos, {notes} notas.",
    "share.card.month.text": "O meu mês de provas ({period}): {wines} vinhos, {notes} notas.",
    "social.invite.session.title": "Convida pessoas para {session}",
    "social.invite.session.lead":
      "Quem abrir a ligação e iniciar sessão entra na lista e participa. A ligação funciona até a prova acabar.",
    "social.invite.joined.remove": "Remover {name}",
    "social.invite.landing.session": "{name} convida-te para {session}.",
    "social.invite.outcome.session": "Vais à prova.",
    "social.invite.outcome.toSession": "Para a prova",
    "social.invite.outcome.toLobby": "Para o lobby",
    "social.invite.install.title": "Põe o proef no ecrã inicial",
    "social.invite.install.body": "Assim voltas a encontrar a prova com facilidade.",
    "social.invite.install.action": "Instalar",
    "social.session.invite.share": "Ligação de convite",
    "social.inbox.link.session": "Ligação para {session}",
    "social.share.sheet.title": "Partilhar fora do proef",
    "social.share.sheet.lead.result": "Só vai o nome da prova, nenhuma nota.",
    "social.share.sheet.lead.wine": "Só vai o nome do vinho, não a tua nota.",
    "social.share.sheet.lead.card":
      "Vão os números do teu cartão, nenhuma nota. Quem abrir a ligação não vê nada da tua conta.",
    "social.share.result.action": "Partilhar os resultados",
    "social.share.tasting.action": "Partilhar",
    "social.share.card.external": "Partilhar fora do proef",
    "social.groups.planTasting": "Planear uma prova",
    "social.sessions.create.friends": "Ou convida amigos",
    "social.sessions.create.noFriends": "Ainda não tens amigos para convidar.",
  },
} as const;
